import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getKuesioner = 'pertanyaan';
const getKuesionerAll = 'pertanyaan';
const postKuesionerUrl = 'pertanyaan';
const putKuesioner = 'pertanyaan/';
const deleteKuesioner = 'pertanyaan/';


class KuesionerService {
    getKuesioner(currentPage, pageSize, filter) {
        return axios.get(
            API_URL + getKuesioner + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter,
            {
                headers: authHeader()
            });
    }
     getKuesionerAll() {
         return axios.get(
             API_URL + getKuesionerAll, {
                 headers: authHeader()
             });
     }

    postKuesioner(formData) {
        return axios
        .post(
            API_URL + postKuesionerUrl,
            formData,
            { headers: authHeader() }
        );
    }

    putKuesioner(formData) {
        var headers = authHeader(); 

        return axios
        .put(
            API_URL + putKuesioner + formData.idPertanyaan, formData,
            { headers: authHeader() }
        );
    }

    deleteKuesioner(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteKuesioner + formData.idPertanyaan,
                { headers: authHeader() }
            );
    }

}

export default new KuesionerService();